<template>
  <div>
    <v-card flat>
      <v-card-text class="text-black pb-2">
        <v-row no-gutters justify="center">
          <v-col cols="12" xl="9" lg="9" md="9">
            <v-row>
              <v-col cols="10">
                <v-icon @click="closeTerritory()">mdi-close</v-icon>
                <span
                  class="mb-0 font-weight-bold"
                  v-if="
                    this.$vuetify.breakpoint.name != 'xl' &&
                      this.$vuetify.breakpoint.name != 'lg' &&
                      this.$vuetify.breakpoint.name != 'md'
                  "
                >
                  {{ truncateString(areaSelected.name, 30) }}
                </span>
                <span class="mb-0 font-weight-bold" v-else>
                  {{ areaSelected.name }}
                </span>
              </v-col>
              <v-col cols="2" class="text-end" v-if="shouldShow">
                <v-menu
                  bottom
                  :offset-x="true"
                  :offset-y="false"
                  transition="slide-x-transition"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on">mdi-dots-vertical</v-icon>
                  </template>
                  <v-list>
                    <v-list-item v-for="item in menu" :key="item.action" link>
                      <v-list-item-title
                        v-text="item.name"
                        @click="selectAction(item.action)"
                      ></v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
            </v-row>
            <p
              class="mb-1 pb-1 text-caption ml-7"
              v-if="areaSelected.landUse"
              @click="showDialog"
            >
              {{ cropNameT }}
            </p>
            <p
              class="mb-1 pb-1 text--gray ml-7"
              v-else
              @click="goToAgronomic()"
            >
              {{ translations.label_add_crop }}
            </p>
            <v-row class="ml-4">
              <v-col cols="4" class="pb-0 pt-1 text-caption">
                <p class="mb-0">{{ areaSize.toFixed(2) }} Ha</p>
              </v-col>
              <v-col cols="8" class="pb-0 pt-1">
                <p
                  v-if="areaSelected.status === 'NOT_STARTED'"
                  class="text-end text-caption"
                >
                  {{ translations.label_sampling_not_started }}
                </p>
                <p v-else class="text-end status_area status--yellow">
                  <v-icon color="yellow darken-2" small class="mb-1"
                    >mdi-timer-sand</v-icon
                  >
                  {{ translations.label_sampling_in_progress }}
                </p>
              </v-col>
            </v-row>
            <v-row class="ml-4" v-if="areaSelected.error">
              <v-col class="pt-0 pb-1">
                <span
                  class="red--text text-caption"
                  v-if="areaSelected.error == 1"
                >
                  {{ translations.label_qr_registered }}
                </span>
                <span
                  class="red--text text-caption"
                  v-else-if="areaSelected.error == 2"
                >
                  {{ translations.label_qr_invalid }}
                </span>
              </v-col>
            </v-row>
            <!-- <v-row justify="space-around" class="mb-0">
            <v-col class="py-0 pr-1">
              <v-btn
                @click="goToLogbook()"
                outlined
                block
                class="secondary--text no_capitalize"
              >
                Ver bitácora
              </v-btn>
            </v-col>
            <v-col class="py-0 pl-1">
              <v-btn
                @click="goToSamples()"
                outlined
                block
                class="secondary--text no_capitalize"
              >
                Ver muestras
              </v-btn>
            </v-col>
          </v-row> -->
          </v-col>
        </v-row>

        <!-- Dialog -->
        <v-dialog v-model="dialogAgronomic" persistent max-width="290">
          <v-card class="cardColor rounded-lg">
            <v-card-title class="text-h6">
              {{ translations.label_agronomic_management }}
            </v-card-title>
            <v-card-text>
              {{ translations.label_confirm_edit_agronomic_management }}
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="green darken-1"
                text
                @click="dialogAgronomic = false"
              >
                {{ translations.cancel }}
              </v-btn>
              <v-btn color="green darken-1" text @click="goToAgronomic()">
                {{ translations.accept }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card-text>
    </v-card>
    <RenameAreaDialog
      v-model="showNameDialog"
      @getName="renameArea"
      :name="areaSelected.name"
    />

    <DialogDeleteConfirmation
      v-model="dialogDelete"
      @deleteArea="deleteAreaDialog"
    />
  </div>
</template>

<script>
import moment from "moment";
// Vuex
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
//components
import RenameAreaDialog from "@/components/territory/modals/RenameAreaDialog";
import DialogDeleteConfirmation from "@/components/territory/modals/DialogDeleteConfirmation";
export default {
  components: {
    RenameAreaDialog,
    DialogDeleteConfirmation,
  },
  data() {
    return {
      menu: [],
      cropNameT: "",
      lastSample: {},
      dialog: false,
      dialogDelete: false,
      showNameDialog: false,
      dialogAgronomic: false,
      shouldShow: true,
      // dialogAddAgronomic: false,
      areaSize: 0,
    };
  },
  async created() {
    this.menu = [
      { name: this.translations.label_rename, action: "rename" },
      { name: this.translations.label_redraw, action: "redraw" },
      { name: this.translations.delete, action: "delete" },
    ];
    let user = JSON.parse(localStorage.getItem("user"));
    if (user.role == "ORG_USER") {
      this.shouldShow = false;
    }
    if (this.areaSelected.areaType != "EXPERIMENTAL" && this.areaSelected.areaType != "SOLENA_NO_ADVISOR") {
      let size = this.computeSignedArea(this.areaSelected.polygon, 6371009.0);
      this.areaSize = size / 10000;
    } else {
      this.areaSize = 0;
    }

    if (this.areaSelected.samples.length > 0) {
      this.lastSample = this.areaSelected.samples[
        this.areaSelected.samples.length - 1
      ];
    }
    await this.getCropName();
  },
  computed: {
    ...mapGetters("session", ["currentTranslations"]),
    translations() {
      return this.currentTranslations;
    },
    ...mapState("areasList", ["areaSelected", "crops"]),
    ...mapState("agronomic", ["lastCropCycle"]),
  },

  methods: {
    ...mapMutations("areasList", [
      "SET_AREA_SELECTED",
      "REPLACE_NAME_SOIL_AREAS",
      "DELETE_SOIL_AREAS",
      "REMOVE_SOIL_AREAS",
      "SET_REDRAW",
      "SET_AREA_REDRAW",
      "SET_ADD_AREA",
    ]),
    ...mapMutations("logs", ["SET_AREA_SELECTED_LOGS"]),
    ...mapMutations("samples", ["SET_AREA_SELECTED_SAMPLE"]),
    ...mapActions("agronomic", ["getCropCycle"]),
    ...mapActions("areasList", ["rename", "deleteArea"]),
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),

    setCropName(name) {
      return this.translations.crop_name_list[name] || name;
    },

    closeTerritory() {
      // this.$emit("closeInfo", true);
      this.SET_AREA_SELECTED(null);
    },
    goToLogbook() {
      this.SET_AREA_SELECTED_LOGS(this.areaSelected);
      this.$router.push(`/logbook?fromAreaDetail=true`);
    },
    goToSamples() {
      this.SET_AREA_SELECTED_SAMPLE(this.areaSelected);
      this.$router.push(`/samples?fromAreaDetail=true`);
    },
    goToAgronomic() {
      if (this.areaSelected) {
        this.$router.push(`/agronomic-management/${this.areaSelected._id}`);
      }
    },
    computeSignedArea(array, radius) {
      let total = 0.0;
      let prev = array[array.length - 1];
      let prevTanLat = Math.tan((Math.PI / 2 - prev.lat * (Math.PI / 180)) / 2);
      let prevLng = prev.lng * (Math.PI / 180);

      for (let point of array) {
        let tanLat = Math.tan((Math.PI / 2 - point.lat * (Math.PI / 180)) / 2);
        let lng = point.lng * (Math.PI / 180);
        total += this.polarTriangleArea(tanLat, lng, prevTanLat, prevLng);
        prevTanLat = tanLat;
        prevLng = lng;
      }

      return Math.abs(total * (radius * radius));
    },

    polarTriangleArea(tan1, lng1, tan2, lng2) {
      let deltaLng = lng1 - lng2;
      let t = tan1 * tan2;
      return 2 * Math.atan2(t * Math.sin(deltaLng), 1 + t * Math.cos(deltaLng));
    },
    async getCropName() {
      if (this.areaSelected.landUse === "sterile") {
        this.cropNameT = this.translations.label_sterile;
      } else {
        try {
          if (this.areaSelected.cropCycles.length > 0) {
            let lastCrop = this.areaSelected.cropCycles[
              this.areaSelected.cropCycles.length - 1
            ];

            let cropResponse = await this.getCropCycle(lastCrop._id);

            if (cropResponse != null) {
              let template = "";

              if (cropResponse.crop.cropName != "") {
                template +=
                  this.translations.label_crop_of +
                  " " +
                  this.setCropName(cropResponse.crop.cropName);
              } else {
                template += this.translations.label_soil_of;
              }

              if (cropResponse.crop.variety != "") {
                template += " (" + cropResponse.crop.variety + ")";
              }

              if (
                cropResponse.plantDate != "" &&
                cropResponse.harvestDate != ""
              ) {
                var firstDate = moment(cropResponse.plantDate);
                var secondDate = moment(cropResponse.harvestDate);
                if (firstDate.isValid() && secondDate.isValid()) {
                  const start = firstDate.valueOf();
                  const end = secondDate.valueOf();
                  const now = moment().valueOf();

                  var diffPartial = end - now;
                  var diffTotal = end - start;

                  var totalDays = diffTotal / (24 * 60 * 60 * 1000);

                  var elapseDays = diffPartial / (24 * 60 * 60 * 1000);

                  if (elapseDays < 0) {
                    template += " - " + this.translations.label_on_hold;
                  } else {
                    var currentDays = totalDays - elapseDays;
                    template +=
                      ` - ${parseInt(currentDays)} ` +
                      this.translations.label_days;
                  }
                }
              }

              this.cropNameT = template;
            }
          } else {
            this.cropNameT = "";
          }
        } catch (error) {
          console.log("ERROR: ", error);
          this.cropNameT = "";
        }
      }
    },
    selectAction(action) {
      switch (action) {
        case "rename":
          this.showNameDialog = true;
          break;
        case "redraw":
          this.SET_AREA_REDRAW(this.areaSelected);
          this.SET_AREA_SELECTED(null);
          this.SET_REDRAW(true);
          this.SET_ADD_AREA(true);
          break;
        case "delete":
          this.dialogDelete = true;
          break;
      }
    },
    async renameArea(value) {
      try {
        let response = await this.rename({
          id: this.areaSelected._id,
          name: value,
        });
        if (response) {
          if (!response.error) {
            this.SET_AREA_SELECTED(response.soilArea);
            this.REPLACE_NAME_SOIL_AREAS(value);
          } else {
            console.log(response.message);
            this.SET_ALERT_TYPE({
              visible: true,
              type: "error",
              text: this.translations.advice_error,
              timeout: 4000,
            });
          }
        } else {
          this.SET_ALERT_TYPE({
            visible: true,
            type: "error",
            text: this.translations.advice_error,
            timeout: 4000,
          });
        }
      } catch (e) {
        console.log(e);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: this.translations.advice_error,
          timeout: 4000,
        });
      }
    },
    async deleteAreaDialog() {
      try {
        let response = await this.deleteArea(this.areaSelected._id);
        if (response) {
          if (!response.error) {
            if (response.code == 1) {
              this.SET_ALERT_TYPE({
                visible: true,
                type: "error",
                text: this.translations.label_cannot_delete_area_with_samples,
                timeout: 5000,
              });
            } else {
              this.REMOVE_SOIL_AREAS(true);
              this.SET_ALERT_TYPE({
                visible: true,
                type: "success",
                text: this.translations.label_area_deleted,
                timeout: 4000,
              });
            }
          } else {
            console.log(response.message);
            this.SET_ALERT_TYPE({
              visible: true,
              type: "error",
              text: this.translations.advice_error,
              timeout: 5000,
            });
          }
        } else {
          this.SET_ALERT_TYPE({
            visible: true,
            type: "error",
            text: this.translations.advice_error,
            timeout: 5000,
          });
        }
      } catch (e) {
        console.log(e);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: this.translations.advice_error,
          timeout: 4000,
        });
      }
    },
    showDialog() {
      if (this.shouldShow) this.dialogAgronomic = true;
    },
    truncateString(str, num) {
      // If the length of str is less than or equal to num
      // just return str--don't truncate it.
      if (str.length <= num) {
        return str;
      }
      // Return str truncated with '...' concatenated to the end of str.
      return str.slice(0, num) + "...";
    },
  },
};
</script>

<style scoped>
.text-black {
  color: #000 !important;
}

.status_area {
  font-size: 0.85rem;
}

.status--yellow {
  color: #fbc02d !important;
}

.no_capitalize {
  text-transform: none;
}

.text--gray {
  color: #888888;
}
</style>
